const PERKS_SHARED: string[] = [
    'coursera.subscriptions.join.amountCourses',
    'coursera.subscriptions.join.amountGuidedProjects',
    'coursera.subscriptions.join.certificatesIncluded',
];
export const PERKS_COMMON: string[] = [
    'coursera.subscriptions.join.subscription',
    ...PERKS_SHARED,
    'coursera.subscriptions.join.cencelAnytime',
];
export const PERKS_EXTENDED: string[] = [
    'coursera.subscriptions.join.oneTimePurchase',
    ...PERKS_SHARED,
    'coursera.subscriptions.join.percentOff',
];

export interface Testimonial {
    text: string;
    author: {
        name: string;
        vocation: string;
        image: string | null;
    };
}
export const TESTIMONIALS: Testimonial[] = [
    {
        text:
            'I have used Coursera and think it’s a great way to complement “traditional “ education. You can study when and where you prefer and also subjects out of your academic curriculum. This implies more diversity and the chance to follow different interests at the same time!',
        author: {
            name: 'Cathe Campe',
            vocation: 'Student',
            image: null,
        },
    },
    {
        text:
            "Having Coursera integrated on my school Centrum's GetHighered platform will allow me to obtain professional certificates on: E-commerce, Google data Analytics, Phyton programming, Software Security and other techno knowlege in demand.",
        author: {
            name: 'Max Galarza',
            vocation: 'Student',
            image: null,
        },
    },
    {
        text:
            'This is a great chance that help us boost our career and explore ourselves further becoming even more competitive!',
        author: {
            name: 'Lilit Hovhannisyan',
            vocation: 'Student',
            image: null,
        },
    },
    {
        text:
            'It’s almost impossible to get to hear about some initiatives, companies or projects if you’re not a student. As we start out studies on university we are all much more into this professional world there we can get a chance to build our future carriers. We just have to be brave enough to reach for this opportunity and chase our dreams. This is a chance for me to build my future by meeting new people and learning new things.',
        author: {
            name: 'Sara Engiel',
            vocation: 'Student',
            image: null,
        },
    },
    {
        text:
            'Coursera is the opportunity to take a better way to increase the knowledge that you acquire with the traditional education.',
        author: {
            name: 'Vieraa Santiago',
            vocation: 'Student',
            image: null,
        },
    },
];
